import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@radix-ui/react-tooltip';
import { cn } from '@/utils';

interface ToolTipProps {
  iconName: string;
  message: string;
  iconClick?: () => void;
  iconStyle?: string;
  messageStyle?: string;
}

const ToolTip: React.FC<ToolTipProps> = ({ iconName, message, iconClick, iconStyle, messageStyle }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger onClick={iconClick}>
          <i
            className={cn(
              `material-symbols-outlined laxu-cursor-pointer laxu-text-2xl laxu-px-1 group-hover:laxu-bg-primary-50 text-xl font-light text-gray-600`,
              iconStyle,
            )}
          >
            {iconName}
          </i>
        </TooltipTrigger>
        <TooltipContent sideOffset={5}>
          <div className={`message rounded-lg bg-white p-1 text-sm ${messageStyle}`}>{message}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ToolTip;
